import { MarketBasketExclusion } from '@domain'
import { Checkbox } from '@mui/material'

export function getColumns(
	setUpdatedSalesforceExclusions: React.Dispatch<React.SetStateAction<MarketBasketExclusion[]>>
) {
	return [
		{
			field: 'customer',
			headerName: 'Customer',
			flex: 2,
			valueGetter: (params) => (params ? `${params.name} - (${params.plid})` : ''),
		},
		{
			field: 'manufacturer',
			headerName: 'Manufacturer',
			flex: 2,
			valueGetter: (params) => (params ? `${params.name} - (${params.plid})` : ''),
		},
		{
			field: 'program',
			headerName: 'Program',
			flex: 1,
			renderCell: ({ value }) => {
				if (value === 'DIRECT') return 'Direct'
				if (value === 'BE_PLATFORM') return 'BE Platform'
				if (value === 'BE_BRAND_EXTENDABLE') return 'BE Brand Extendable'
				if (value === 'ENTEGRA') return 'Entegra'
				return value || '-'
			},
		},
		{
			field: 'source',
			headerName: 'Source',
			flex: 2,
			valueGetter: (params) => params || '',
		},
		{
			field: 'enabled',
			headerName: 'Enabled',
			headerAlign: 'center',
			align: 'center',
			sortable: false,
			flex: 1,
			renderCell: ({ row }) => (
				<Checkbox
					checked={row.enabled}
					onChange={() =>
						setUpdatedSalesforceExclusions((prev: MarketBasketExclusion[]) => {
							if (prev.find((exclusion) => exclusion.id === row.id)) {
								return prev.filter((exclusion) => exclusion.id !== row.id)
							}
							return [...prev, { ...row, enabled: !row.enabled }]
						})
					}
				/>
			),
		},
	]
}
